import React from "react";
import { DisplayDiscussionForMiniScreenProvider } from "../contexts/DisplayDiscussionForMiniScreenContext";
import Navbar from "../components/Navbar";
import ContentSquelette from "../layouts/ContentSquelette";
import OffCanvas from "../components/OffCanvas";
import HeadTools from "../components/OffCanvasComponents/HeadTools";
// import Recherche from "../components/OffCanvasComponents/Recherche";
import OffCanvasMessagesGroupe from "../components/OffCanvasComponents/OffCanvasMessagesGroupe";
import DiscussionGroupe from "../components/DiscussionGroupe";
import { CritereFiltreProvider } from "../contexts/CriteresFiltreContext";

export default function GroupesPage() {
  return (
    <>
      <DisplayDiscussionForMiniScreenProvider>
        <Navbar />
        <ContentSquelette>
          <CritereFiltreProvider>
            <OffCanvas
              panel="Groupes"
              headRight={<HeadTools page="Groupes" />}
              // recherche={<Recherche />}
            >
              <OffCanvasMessagesGroupe />
            </OffCanvas>
            <DiscussionGroupe />
          </CritereFiltreProvider>
        </ContentSquelette>
      </DisplayDiscussionForMiniScreenProvider>
    </>
  );
}
